import { render, staticRenderFns } from "./card-nav.vue?vue&type=template&id=2bce9fa0&scoped=true&"
import script from "./card-nav.vue?vue&type=script&lang=js&"
export * from "./card-nav.vue?vue&type=script&lang=js&"
import style0 from "./card-nav.vue?vue&type=style&index=0&id=2bce9fa0&scoped=true&lang=less&rel=stylesheet%2Fless&"
import style1 from "./card-nav.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce9fa0",
  null
  
)

export default component.exports